/**
 * Backoff du bootstrap des comptes (`GET /api/auth/accounts`).
 *
 * Un ÉCHEC DE RÉCUPÉRATION (panne réseau, 429 du limiteur, 5xx) n'est PAS une
 * déconnexion : le cookie de session peut être parfaitement valide. L'état est
 * alors « indéterminé » et doit être RÉESSAYÉ tout seul — sans quoi l'app reste
 * bloquée sur un écran d'erreur jusqu'à ce que l'utilisateur clique.
 *
 * Le cas qui motive ce backoff : au redémarrage du navigateur, la restauration
 * simultanée des onglets produit une RAFALE de requêtes ; un échec transitoire y
 * est bien plus probable qu'en navigation normale.
 *
 * Délais croissants puis plafonnés (le dernier est répété indéfiniment) : on ne
 * renonce jamais, mais on n'inonde pas un serveur déjà en difficulté.
 */
export const ACCOUNTS_RETRY_DELAYS_MS: readonly number[] = [400, 1_000, 2_500, 5_000, 10_000];

/** Délai (ms) avant la tentative suivante, pour une tentative déjà échouée d'index `attempt` (0-based). */
export function accountsRetryDelayMs(attempt: number): number {
  const index = Math.min(Math.max(attempt, 0), ACCOUNTS_RETRY_DELAYS_MS.length - 1);
  return ACCOUNTS_RETRY_DELAYS_MS[index]!;
}
